<div
	class="badge-typeahead"
	[attr.aria-label]="
		'lup.typeahead.chips.list_description' | translate: { chip_index: index + 1, chips_length: chipsLength }
	">
	<span class="ellipsis" [ngClass]="primaryField.class">{{ primaryField.value }}</span>
	<span
		role="button"
		class="btn btn--icon btn--ico badge-typeahead__remove-chip"
		(click)="$event.stopPropagation(); close()"
		[title]="('remove' | translate) + ' ' + primaryField.value">
		<lu-icon class="btn__ico" icon="times"></lu-icon>
	</span>
</div>
